




































































































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import GStudentRecordCompetencyScoreTransition from '@/views/GStudentRecord/GStudentRecordCompetencyScoreTransition.vue';
import GTopicSubject from '@/components/GTopicSubject.vue';
import GStudentRecordScoreComparison from '@/views/GStudentRecord/GStudentRecordScoreComparison.vue';
import GCompetencyDistribution from '@/components/GCompetencyDistribution.vue';
import { StudentCompetencyComparison, StudentCompetencyData } from '@/models/student/student-competency-data';
import { studentModule } from '@/store/modules/entities/student.module';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GStudentRecord from '@/views/GStudentRecord/GStudentRecord.vue';
import { CompetencyDistributionEchartService } from '@/service/echart/competency-distribution.echart.service';
import GOptionalData from '@/components/GOptionalData.vue';
import { GPageBase } from '@/mixins';
import { ScoreUtils } from '@/utils/score.utils';

@Component({
  name: 'GStudentRecordGrowth',
  components: { GOptionalData, GStudentRecord, GCompetencyLabel, GCompetencyDistribution, GStudentRecordScoreComparison, GTopicSubject, GStudentRecordCompetencyScoreTransition },
  computed: {},
  methods: {},
})
export default class GStudentRecordGrowth extends Mixins(GPageBase) {
  readonly CHART_HEIGHT: number = 180;

  @Prop() studentID: number;

  mounted() {}

  getScoreProgressStatusString(count: number, isNew: boolean): string {
    return ScoreUtils.toStringScoreProgressStatus(count, isNew);
  }

  get studentFirstThreeCompetencies(): StudentCompetencyComparison[] {
    if (this.studentCompetencyData.competencyComparisons) {
      return this.studentCompetencyData.competencyComparisons.slice(0, 3);
    }
  }

  get studentCompetencyData(): StudentCompetencyData {
    return studentModule.studentCompetencyData;
  }

  // 高いコンピテンシーの分布図用のパラメータ
  get highCompetencyOption(): any {
    const highCompetencyDistribution: CompetencyDistributionEchartService = new CompetencyDistributionEchartService(
      this.CHART_HEIGHT,
      this.studentCompetencyData.highCompetency.target,
      this.studentCompetencyData.highCompetency.organization
    );
    return highCompetencyDistribution.options;
  }

  // 低いコンピテンシーの分布図用のパラメータ
  get lowCompetencyOption(): any {
    const lowCompetencyDistribution: CompetencyDistributionEchartService = new CompetencyDistributionEchartService(
      this.CHART_HEIGHT,
      this.studentCompetencyData.lowCompetency.target,
      this.studentCompetencyData.lowCompetency.organization
    );
    return lowCompetencyDistribution.options;
  }

  // 伸ばしやすいコンピテンシーの分布図用のパラメータ
  get potentialCompetencyOption(): any {
    const potentialCompetencyDistribution: CompetencyDistributionEchartService = new CompetencyDistributionEchartService(
      this.CHART_HEIGHT,
      this.studentCompetencyData.potentialCompetency.target,
      this.studentCompetencyData.potentialCompetency.organization
    );
    return potentialCompetencyDistribution.options;
  }

  get studentFirstThreeCompetencyGrowth(): StudentCompetencyGrowth[] {
    return this.sortDiffScore.slice(0, 3);
  }

  get sortDiffScore(): StudentCompetencyGrowth[] {
    return studentAllCompetencyModule.sortDiffScore;
  }

  // studentFirstThreeCompetencyGrowth の持つ courseResult の中身が2つ以上存在するものが1つ以上あるか
  get hasCourseResultLength2Growth(): boolean {
    const count = this.studentFirstThreeCompetencyGrowth.filter((scg: StudentCompetencyGrowth) => scg.courseResults.length > 1).length;
    return count > 0 ? true : false;
  }
}
